export default __webpack_public_path__ + "static/media/profile.ac42d65b.jpeg";